import React, { useEffect } from 'react';
import { TextField } from '@material-ui/core';
import InputMask from 'react-input-mask';
import { IconButton } from '@mui/material';
import { useDispatch } from 'react-redux';
import { ButtonWithLoader } from '../../../components/ui/Buttons';
import { TAuthTabs } from '.';
import Resend from '../../../components/resend';
import ArrowBack from './icons/ArrowBack';
import { useAxiosEnterPassword } from '../hooks/useAxiosEnterPassword';
import { useFormikEnterPassword } from '../hooks/useFormikEnterPassword';
import { actions as authActions } from '../../../store/ducks/auth.duck';

interface IProps {
  changeAuthTab: (newTab: TAuthTabs, props?: any) => void;
  email: string;
}

export const EnterPassword: React.FC<IProps> = ({ changeAuthTab, email }) => {
  const dispatch = useDispatch();

  const { makeRequest, loading, res } = useAxiosEnterPassword();
  const formik = useFormikEnterPassword(makeRequest);

  // on success
  useEffect(() => {
    if (res) {
      dispatch(authActions.loginSuccess(res));
    }
  }, [res]);

  const onResend = async () => {
    return true
  }

  return (
    <div className='kt-login__body'>
      <div className='kt-login__form'>
        <div className='kt-login__title'>
          <h3>6-digit code</h3>
        </div>

        <h5 style={{ color: 'rgba(42, 52, 72, 0.45)', marginBottom: 30}}>
          Enter the code generated by your authenticator app
        </h5>

        <form noValidate autoComplete='off' className='kt-form' onSubmit={formik.handleSubmit}>
          <div style={{marginBottom: 60}} className='form-group'>
            <InputMask
              mask='9 9 9  9 9 9'
              onBlur={formik.handleBlur}
              onChange={formik.handleChange}
              value={formik.values.password}
            >
              {(inputProps: any) => (
                <TextField
                  style={{
                    width: '50%',
                    display: 'flex',
                    justifyContent: 'center',
                    letterSpacing: '3px',
                    marginBottom: 20,
                    marginTop: 20,
                  }}
                  variant='outlined'
                  type='text'
                  margin='normal'
                  className='custom-centered-input'
                  name='password'
                  autoFocus
                  {...inputProps}
                  helperText={formik.touched.password && formik.errors.password}
                  error={Boolean(formik.touched.password && formik.errors.password)}
                />
              )}
            </InputMask>

            <Resend 
              submitText="Lost acsess to authenticator app? "
              cooldownText="Resend code in"
              cooldownDuration={60000}
              onPress={onResend}
            />
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-start',
              alignItems: 'center',
              marginTop: 20
            }}
          >
            <div className='kt-login__actions' style={{ marginRight: 20 }}>
              <IconButton style={{padding: 0, margin: 0}} onClick={() => changeAuthTab('CheckInSystem', { initEmail: email })} >
                <ArrowBack />
              </IconButton>
            </div>

            <ButtonWithLoader
              style={{width: '100%'}}
              onPress={formik.handleSubmit}
              disabled={loading}
              loading={loading}
            >
                Next
            </ButtonWithLoader>
          </div>
        </form>
      </div>
    </div>
  );
};
